import $ from 'jquery';
import Backbone from 'backbone';
import Mn from 'backbone.marionette';
import app from './app';
import { exchangeOAuthCode } from './auth/oauth';

const AuthController = (Mn.Object as any).extend({
  initialize() {},

  change_title(title: string) {
    const newTitle = title ? `${title} | HG Insights` : 'HG Insights';
    $(document).attr('title', newTitle);
  },

  track_page(title: string) {
    return title && window.analytics && window.analytics.page(title);
  },

  async oauthCallback() {
    try {
      // Exchange OAuth code for tokens (sets cookies)
      await exchangeOAuthCode();

      // Fetch user/tenant data using existing session model
      // app.session.check_auth() does fetch() + store() which populates user/tenant
      try {
        await app.session.check_auth();
      } catch (error) {
        // If fetching user data fails after OAuth, redirect to home
        // User can try again from there
        console.error('Failed to fetch user data after OAuth:', error);
        window.location.href = '/';
        return;
      }

      // Get destination route
      const redirect = sessionStorage.getItem('oauth_redirect') || '/';
      sessionStorage.removeItem('oauth_redirect');

      // Redirect to destination or home
      Backbone.history.navigate(redirect, { trigger: true });
    } catch (error) {
      // Error already handled in exchangeOAuthCode or above
      console.error('OAuth callback failed:', error);
      // exchangeOAuthCode will redirect to / on failure
    }
  },
});

export default Mn.AppRouter.extend({
  appRoutes: {
    'oauth/callback': 'oauthCallback',
  },

  initialize() {
    this.controller = new AuthController({});
  },
});
